import { render, staticRenderFns } from "./MyYearPageLink.vue?vue&type=template&id=2bd76fea"
import script from "./MyYearPageLink.vue?vue&type=script&lang=js"
export * from "./MyYearPageLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports